import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function Hero() {
  return (
    <section className="section-padding">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16 items-center">
        {/* Text Content */}
        <div className="lg:col-span-3">
          {/* Available Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-50 border border-green-200 rounded-full mb-6 fade-in">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
            <span className="text-sm text-green-700 font-medium">available for opportunities</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-display font-fraunces mb-6 fade-in" style={{ animationDelay: '0.05s' }}>
            Deepali Agrawal
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl font-fraunces text-warm-gray-700 mb-8 fade-in" style={{ animationDelay: '0.1s' }}>
            Visual Designer working with brands, stories, and details that last.
          </p>

          {/* Description */}
          <p className="text-body-lg text-warm-gray-600 max-w-prose mb-10 fade-in" style={{ animationDelay: '0.2s' }}>
            I design brand and communication systems that are thoughtful, grounded, and quietly expressive — shaped by context, craft, and intention.
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap gap-4 fade-in" style={{ animationDelay: '0.3s' }}>
            <a
              href="https://www.behance.net/gallery/243301925/Visual-Designer-Portfolio-2026"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              View Work
            </a>
            <Link to="/contact" className="btn-secondary group">
              Let's Work Together
              <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>

        {/* Avatar Image */}
        <div className="lg:col-span-2 flex justify-center lg:justify-end fade-in" style={{ animationDelay: '0.2s' }}>
          <div className="relative w-3/4 max-w-sm group cursor-pointer">
            {/* Soft grey shadow block */}
            <div className="absolute inset-0 translate-x-4 translate-y-4 bg-warm-gray-200 rounded-2xl -rotate-2 transition-all duration-500 ease-out group-hover:translate-x-2 group-hover:translate-y-2 group-hover:rotate-0" />

            {/* Image container */}
            <div className="aspect-square rounded-2xl overflow-hidden bg-cream-dark -rotate-2 relative shadow-sm transition-all duration-500 ease-out group-hover:-rotate-0 group-hover:scale-[1.02]">
              <img
                src="/images/avatar.png"
                alt="Deepali Agrawal"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}